import { PropTypes } from 'prop-types'

const Link = ({ text, href }) => {
  return (
    <a href={href} className="text-primary hover:text-primary hover:underline">
      {text}
    </a>
  )
}

Link.propTypes = {
  text: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
}

export default Link
